"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisposableNone = void 0;
exports.DisposableNone = Object.freeze({ dispose: function () { } });
//# sourceMappingURL=dispose-type.js.map